"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseColor = parseColor;
exports.formatColor = formatColor;

var _colorName = _interopRequireDefault(require("color-name"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var HEX = /^#([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i;
var SHORT_HEX = /^#([a-f\d])([a-f\d])([a-f\d])([a-f\d])?$/i;
var VALUE = /(?:\d+|\d*\.\d+)%?/;
var SEP = /(?:\s*,\s*|\s+)/;
var ALPHA_SEP = /\s*[,/]\s*/;
var CUSTOM_PROPERTY = /var\(--(?:[^ )]*?)\)/;
var RGB = new RegExp("^(rgb)a?\\(\\s*(".concat(VALUE.source, "|").concat(CUSTOM_PROPERTY.source, ")(?:").concat(SEP.source, "(").concat(VALUE.source, "|").concat(CUSTOM_PROPERTY.source, "))?(?:").concat(SEP.source, "(").concat(VALUE.source, "|").concat(CUSTOM_PROPERTY.source, "))?(?:").concat(ALPHA_SEP.source, "(").concat(VALUE.source, "|").concat(CUSTOM_PROPERTY.source, "))?\\s*\\)$"));
var HSL = new RegExp("^(hsl)a?\\(\\s*((?:".concat(VALUE.source, ")(?:deg|rad|grad|turn)?|").concat(CUSTOM_PROPERTY.source, ")(?:").concat(SEP.source, "(").concat(VALUE.source, "|").concat(CUSTOM_PROPERTY.source, "))?(?:").concat(SEP.source, "(").concat(VALUE.source, "|").concat(CUSTOM_PROPERTY.source, "))?(?:").concat(ALPHA_SEP.source, "(").concat(VALUE.source, "|").concat(CUSTOM_PROPERTY.source, "))?\\s*\\)$"));

function parseColor(value) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$loose = _ref.loose,
      loose = _ref$loose === void 0 ? false : _ref$loose;

  var ref, ref1;

  if (typeof value !== "string") {
    return null;
  }

  value = value.trim();

  if (value === "transparent") {
    return {
      mode: "rgb",
      color: ["0", "0", "0"],
      alpha: "0"
    };
  }

  if (value in _colorName.default) {
    return {
      mode: "rgb",
      color: _colorName.default[value].map(function (v) {
        return v.toString();
      })
    };
  }

  var hex = value.replace(SHORT_HEX, function (_, r, g, b, a) {
    return ["#", r, r, g, g, b, b, a ? a + a : ""].join("");
  }).match(HEX);

  if (hex !== null) {
    return {
      mode: "rgb",
      color: [parseInt(hex[1], 16), parseInt(hex[2], 16), parseInt(hex[3], 16)].map(function (v) {
        return v.toString();
      }),
      alpha: hex[4] ? (parseInt(hex[4], 16) / 255).toString() : undefined
    };
  }

  var ref2;
  var match = (ref2 = value.match(RGB)) !== null && ref2 !== void 0 ? ref2 : value.match(HSL);

  if (match === null) {
    return null;
  }

  var color = [match[2], match[3], match[4]].filter(Boolean).map(function (v) {
    return v.toString();
  });

  if (!loose && color.length !== 3) {
    return null;
  }

  if (color.length < 3 && !color.some(function (part) {
    return /^var\(.*?\)$/.test(part);
  })) {
    return null;
  }

  return {
    mode: match[1],
    color: color,
    alpha: (ref = match[5]) === null || ref === void 0 ? void 0 : (ref1 = ref.toString) === null || ref1 === void 0 ? void 0 : ref1.call(ref)
  };
}

function formatColor(_ref2) {
  var mode = _ref2.mode,
      color = _ref2.color,
      alpha = _ref2.alpha;
  var hasAlpha = alpha !== undefined;
  return "".concat(mode, "(").concat(color.join(" ")).concat(hasAlpha ? " / ".concat(alpha) : "", ")");
}